import React, { Component } from 'react';
import { Card, CardBody, Col, Dropdown, DropdownToggle, Modal, ModalBody, ModalHeader, CardTitle, Input, CustomInput, FormGroup, Label, Button} from "reactstrap";
import S3 from 'react-aws-s3';
import { Link } from "react-router-dom";

//Simple bar
import SimpleBar from "simplebar-react";
import { testimonyFormOptionsUrl, victimDetentionUrl } from '../../helpers/url';

class RecentlyActivity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : false,
            modal_center: false,
            loading: true,
            success: false,
            successMessage: "",
            formFieldData: [],
            tempDetentionId: 0,
			tempDetentionStatusId: '0',
			tempDetentionOther: '',
			tempDetentionClarification: '',
			tempDetentionReason: '',
			tempDetentionPossesionOfInformation: '',
			tempDetentionAddress: '',
			tempDetentionDocument: '',
			tempDetentionLocationId: 1,
			tempDetentionStatusYearFrom: '',
			tempDetentionStatusYearTo: '',
			tempDetentionStatusMonthFrom: '',
			tempDetentionStatusMonthTo: '',
			tempDetentionStatusDayTo: '',
			tempDetentionStatusDayFrom: '',
        }
        this.tog_center = this.tog_center.bind(this);
    }
    
    componentDidMount() {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(testimonyFormOptionsUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                formFieldData: data,
                loading: false
            })
        })
    }

    fileSubmitToS3 = async (event) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(event.target.files[0], 'testimony/' + this.props.victimId + '/detention/' + event.target.files[0].name)
			.then(data => {
				if (data && data.location) {
                    this.setState({
                        tempDetentionDocument: data.location,
                    });
				} else {
					this.setState({
						error: true,
						errorMsg: 'File could not be uploaded',
					});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

    stateHandling = (event) => {
        let targetId = event.target.id;
		let targetValue = event.target.value;
		let targetType = event.target.type;
        console.log(targetId, targetValue, targetType)
		if (targetType === 'text' || targetType === "textarea") {
            this.setState({
                [targetId]: targetValue,
			});
        }
        else if (targetType === 'number' || targetType === 'select-one') {
			if (targetValue === isNaN) {
				targetValue = 0;
			}
			this.setState({
				[targetId]: parseInt(targetValue),
			});
        }
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
      }
    
    submit = () => {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(victimDetentionUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify([{
                "detentionId": 0,
                "statusId": this.state.tempDetentionStatusId,
                "other":this.state.tempDetentionOther,
                "clarification":this.state.tempDetentionClarification,
                "reason":this.state.tempDetentionReason,
                "possesionOfInformation":this.state.tempDetentionPossesionOfInformation,
                "detentionAddress":this.state.tempDetentionAddress,
                "document":this.state.tempDetentionDocument,
                "locationId": this.state.tempDetentionLocationId,
                "victimId":this.props.victimId,
                "detainedFromYear": '' ? 0 : this.state.tempDetentionStatusYearFrom,
                "detainedFromMonth": '' ? 0 :this.state.tempDetentionStatusMonthFrom,
                "detainedFromDay": '' ? 0 :this.state.tempDetentionStatusDayFrom,
                "detainedToYear": '' ? 0 :this.state.tempDetentionStatusYearTo,
                "detainedToMonth": '' ? 0 :this.state.tempDetentionStatusMonthTo,
                "detainedToDay": '' ? 0 : this.state.tempDetentionStatusDayTo
            }])
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                success: true,
                successMessage: "Submitted!"
            })
        })
    }

    render() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div>
                        LOADING
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.success) {
            return (
                <React.Fragment>
                    <div>
                        {this.state.successMessage}
                    </div>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Dropdown className="float-right" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                                            <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="true">
                                                <Link><i className="mdi mdi-book-plus-multiple-outline" onClick={this.tog_center}></i></Link>

                                                <Modal
                                                    size="lg"
                                                    isOpen={this.state.modal_center}
                                                    toggle={this.tog_center}
                                                    centered={true}
                                                    >
                                                    <ModalHeader toggle={() => this.setState({ modal_center: false })}>
                                                            Detention Information - Add
                                                    </ModalHeader>
                                                    <ModalBody>
                                                    <CardTitle className="h5 mb-3 text-center"></CardTitle>
															<Card>
																<CardBody>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">Detention Status</Label>
																		<Col md={9}>
																			<select
																				className="custom-select"
																				id="tempDetentionStatusId"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusId}>
																				{this.state.formFieldData.victimStatus.map((data, id) => (
																					<option key={id} value={data.id}>
																						{data.statusEN}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	{this.state.tempDetentionStatusId === '1' ? (
																		<FormGroup row>
																			<Label className="col-md-2 col-form-label">Detention Status Other</Label>
																			<Col md={9}>
																				<Input
																					type="textarea"
																					id="tempDetentionOther"
																					rows="1"
																					placeholder="Any other clarification such as what he/she was doing while this event occured"
																					value={this.state.tempDetentionOther}
																					onChange={event => {
																						this.stateHandling(event);
																					}}
																				/>
																			</Col>
																		</FormGroup>
																	) : (
																		''
																	)}
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Reason for arrest (detention)
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionReason"
																				rows="3"
																				placeholder="Reason for detention"
																				value={this.state.tempDetentionReason}
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Additional info/Clarification
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionClarification"
																				rows="3"
																				placeholder="Any other clarification such as what he/she was doing while this event occured"
																				value={this.state.tempDetentionClarification}
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Source of Information
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionPossesionOfInformation"
																				rows="3"
																				placeholder="How the information was gathered"
																				value={this.state.tempDetentionPossesionOfInformation}
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Detention Address
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionAddress"
																				rows="3"
																				placeholder="How the information was gathered"
																				value={this.state.tempDetentionAddress}
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">Location</Label>
																		<Col md={9}>
																			<select
																				className="custom-select"
																				id="tempDetentionLocationId"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionLocationId}>
																				{this.state.formFieldData.internmentLocations.map((data, id) => (
																					<option key={id} value={data.id}>
																						{data.name}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Arrest (detention), Date From
																		</Label>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Year"
																				id="tempDetentionStatusYearFrom"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusYearFrom}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Month"
																				id="tempDetentionStatusMonthFrom"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusMonthFrom}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Day"
																				id="tempDetentionStatusDayFrom"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusDayFrom}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Arrest (detention), Date To
																		</Label>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Year"
																				id="tempDetentionStatusYearTo"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusYearTo}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Month"
																				id="tempDetentionStatusMonthTo"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusMonthTo}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Day"
																				id="tempDetentionStatusDayTo"
																				onChange={event => {
																					this.stateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusDayTo}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Document
																		</Label>
																		<Col md={9}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file"
																					className="custom-file-input"
																					id="tempDetentionFileHolder"
																					onChange={event => {
																						this.fileSubmitToS3(event);
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempDetentionFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																		<Col md={9}>
																			<div className="text-center">
																				{this.state.tempDetentionDocument !== '' ? (
																					<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																						{this.state.tempDetentionDocument.substr(this.state.tempDetentionDocument.length - 3)} Ready
																					</Label>
																				) : (
																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>
                                                                    <FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.submit();
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
															    </CardBody>
                                                            </Card>
                                                    </ModalBody>
                                                </Modal>
                                            </DropdownToggle>
                                            {/* <DropdownMenu right>
                                                <DropdownItem href="">Add</DropdownItem>
                                            </DropdownMenu> */}
                                        </Dropdown>

                                        <h4 className="card-title mb-4">Detention Status</h4>

                                        <SimpleBar style={{ maxHeight: "330px" }}>
                                            <ul className="list-unstyled activity-wid">
												{console.log(this.props.detention)}
                                                {this.props.detention.map((each, key) => 
                                                    <li className="activity-list">
                                                        <div className="activity-icon avatar-xs">
                                                            <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                                <i className="ri-edit-2-fill"></i>
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <h5 className="font-size-13"><small className="text-muted">From </small>{each.detainedFromDay}.{each.detainedFromMonth}.{each.detainedFromYear}</h5>
                                                            </div>
                                                            <div>
                                                                <h5 className="font-size-13"><small className="text-muted">To </small>{each.detainedToDay}.{each.detainedToMonth}.{each.detainedToYear}</h5>
                                                            </div>
                                                            <div>
                                                                <p className="text-muted mb-0"><small className="text-muted">Location</small> {each.locationId}</p>
                                                            </div>
															<div>
                                                                <p className="text-muted mb-0"><small className="text-muted">Clarification</small> {each.clarification}</p>
                                                            </div>
															<div>
                                                                <p className="text-muted mb-0"><small className="text-muted">Reason</small> {each.reason}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                        </SimpleBar>
                                    </CardBody>
                                </Card>
                            </Col>
            </React.Fragment>
        );
    }
}

export default RecentlyActivity;